import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SmartAction } from '@connect-x-app/shared-domain-models';
import { createColumnHelper, getCoreRowModel, useReactTable } from '@tanstack/react-table';

import { TableCell, TableHeader } from '../../../../../shared';
import { SMART_ACTIONS_COLUMN_SIZE } from './smartActionsTable.constants';

const columnHelper = createColumnHelper<SmartAction>();

export const useSystemSmartActionTable = (data: SmartAction[]) => {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      columnHelper.accessor('name', {
        cell: props => <TableCell {...props} />,
        header: props => <TableHeader {...props} title={t('SMART_ACTIONS_COLUMN_NAME')} />,
        id: 'Name',
        size: SMART_ACTIONS_COLUMN_SIZE.NAME,
      }),
      columnHelper.accessor('description', {
        cell: props => <TableCell {...props} />,
        header: props => <TableHeader {...props} title={t('SMART_ACTIONS_COLUMN_DESCRIPTION')} />,
        id: 'Description',
        size: SMART_ACTIONS_COLUMN_SIZE.DESCRIPTION,
      }),
    ],
    [t],
  );

  return useReactTable({
    columns,
    data,
    enableRowSelection: false,
    getCoreRowModel: getCoreRowModel(),
    getRowId: row => row.id,
  });
};
